// extracted by mini-css-extract-plugin
module.exports = {"pad":"Home_pad__1HZr1","div3":"Home_div3__TTNNf"};